import { receivablesService } from '@/api/receivables.service';
import type {
  ReceivablesControllerGetDownpaymentsData,
  ReceivablesControllerGetItemsData,
} from '@carvia/ros-client-types';
import { useQueries, useQuery } from '@tanstack/vue-query';
import { computed, type MaybeRefOrGetter, toRef, toValue } from 'vue';

const QUERY_KEY = 'receivables';

export const useReceivablesSummary = (
  query: MaybeRefOrGetter<
    Pick<
      NonNullable<ReceivablesControllerGetItemsData['query']>,
      'invoiceTypes' | 'hasPeriodicInvoicing' | 'isDeposit' | 'search'
    >
  >,
) => {
  return useQuery({
    queryKey: [QUERY_KEY, 'summary', toRef(query)],
    queryFn: () => receivablesService.getSummary(toValue(query)),
  });
};

export const useReceivablesItems = (
  query: MaybeRefOrGetter<ReceivablesControllerGetItemsData['query']>,
) => {
  return useQuery({
    queryKey: [QUERY_KEY, 'items', toRef(query)],
    queryFn: () => receivablesService.getItems(toValue(query)),
    enabled: computed(() => typeof toValue(query)?.dueDays === 'number'),
  });
};

export const useReceivablesProblems = () => {
  return useQuery({
    queryKey: [QUERY_KEY, 'problems'],
    queryFn: () => receivablesService.getProblems(),
  });
};

export const useReceivablesDownpayments = (
  query?: MaybeRefOrGetter<ReceivablesControllerGetDownpaymentsData['query']>,
) => {
  return useQuery({
    queryKey: [QUERY_KEY, 'downpayments', toRef(query ?? {})],
    queryFn: () => receivablesService.getDownpayments(toValue(query)),
  });
};
